<template>
  <div class="table-page">
    <vue-table :table-data="tableData" ref="vueTable">
      <template slot="searchBar">
        <el-form-item label="角色名称">
          <el-input v-model.trim="tableData.search.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model.trim="tableData.search.describe" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button v-if="checkApi('addRole')" size="small" type="primary" @click="add">添加</el-button>
      </template>
      <template v-if="hasApi(['getRolePermission','modifyRole','deleteRole'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="150">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('getRolePermission')" type="text" @click="showPermission(row)">查看权限</el-button>
            <el-button v-if="checkApi('modifyRole')" type="text" @click="modify(row)">修改</el-button>
            <el-button v-if="checkApi('deleteRole')" type="text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <table-operate v-if="tableOperate.visible" :dialog-data="tableOperate" @getData="getData"/>
    <role-permission v-if="rolePermission.visible" :dialog-data="rolePermission"/>
  </div>
</template>

<script>
import TableOperate from "./dialog/TableOperate"
import RolePermission from "./dialog/RolePermission"
export default {
  name: "deviceList",
  components: {TableOperate,RolePermission},
  data() {
    return {
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "角色名称", property: "name"},
          {label: "描述", property: "describe"},
          {label: "创建时间", property: "create_at"},
        ],
        api: "getRoleList",
        search: {
          name: "",
          describe: "",
        }
      },
      tableOperate: {visible: false, title: "", row: null, width: 750},
      rolePermission: {visible: false, title: "角色权限", row: null, hideBtn: true, width: 750},
    }
  },
  methods: {
    add() {
      this.tableOperate.title = "添加";
      this.tableOperate.visible = true;
      this.tableOperate.row = null;
    },
    modify(row) {
      this.tableOperate.title = "修改";
      this.tableOperate.visible = true;
      this.tableOperate.row = row;
    },
    remove(row) {
      this.openConfirm("删除该项", async ()=> {
        let nv = {};
        nv.role_id = row.id;
        let res = await this.$Http.deleteRole(nv);
        if (res) {
          this.msgSuccess("删除成功");
          this.getData();
        }
      });
    },
    showPermission(row) {
      this.rolePermission.visible = true;
      this.rolePermission.row = row;
    },
    getData() {
      this.$refs["vueTable"].refresh();
    },
  },
}
</script>

<style scoped>

</style>
